import { provideApollo } from 'apollo-angular';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { LocationStrategy } from '@angular/common';
import { provideClientHydration } from '@angular/platform-browser';
import { AuthGuard } from './core/guards/auth.guard';
import { PathPreserveQueryLocationStrategy } from './core/services/location-srategy.service';
import { PreviewModeService } from './core/services/preview-mode.service';
import { RedirectService } from './core/services/redirect.service';
import { ProgramDataService } from './core/services/program-data.service';
import { createApollo, MY_APOLLO_CACHE } from './graphql.config';
import { routes } from './app-routing';
import { PreloadAllModules, provideRouter, withRouterConfig, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PROGRAM_DATA_SERVICE } from 'khegm-ui-components';

export function initPreviewMode(preview: PreviewModeService) {
  return (): Promise<any> => {
    return preview.setPreviewMode();
  }
}

export function initRedirects(redirectService: RedirectService) {
  return () => {
    // Skip loading redirects during SSR - IIS handles server-side redirects
    if (typeof window === 'undefined') {
      return;
    }
    // Fire-and-forget: do not block APP_INITIALIZER on redirects loading
    void redirectService.loadRedirects();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: MY_APOLLO_CACHE, useValue: new InMemoryCache() },
    { provide: APP_INITIALIZER, useFactory: initPreviewMode, deps: [PreviewModeService], multi: true },
    { provide: APP_INITIALIZER, useFactory: initRedirects, deps: [RedirectService], multi: true },
    { provide: LocationStrategy, useClass: PathPreserveQueryLocationStrategy },
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideApollo(createApollo),
    provideAnimations(),
    provideRouter(routes, withRouterConfig({ urlUpdateStrategy: 'eager', }), withPreloading(PreloadAllModules),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    AuthGuard,
    { provide: PROGRAM_DATA_SERVICE, useExisting: ProgramDataService }
  ]
};
